module.exports = __webpack_public_path__ + "img/leader_cs_m.41893b37.svg";